import { useMemo } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAtomValue } from 'jotai';

import { tokenAtom, isAuthenticatedAtom, profileAtom } from '@/store';

export default function AuthGuard() {
  const location = useLocation();
  const token = useAtomValue(tokenAtom);
  const isAuthenticated = useAtomValue(isAuthenticatedAtom);

  // Mount-time bootstrap: subscribe to profile to ensure /me is fetched when token exists
  useAtomValue(profileAtom);

  const isAuthed = useMemo(() => {
    return Boolean(token) || Boolean(isAuthenticated);
  }, [token, isAuthenticated]);

  if (!isAuthed) {
    const redirect = encodeURIComponent(location.pathname + location.search);

    return <Navigate replace to={`/login?redirect=${redirect}`} />;
  }

  return <Outlet />;
}
